import { render, staticRenderFns } from "./necessary.vue?vue&type=template&id=c7072e28&scoped=true&"
import script from "./necessary.vue?vue&type=script&lang=js&"
export * from "./necessary.vue?vue&type=script&lang=js&"
import style0 from "./necessary.vue?vue&type=style&index=0&id=c7072e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7072e28",
  null
  
)

export default component.exports